"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSession = void 0;
var solid_client_authn_browser_1 = require("@inrupt/solid-client-authn-browser");
exports.authSession = new solid_client_authn_browser_1.Session({
    clientAuthentication: (0, solid_client_authn_browser_1.getClientAuthenticationWithDependencies)({})
}, 'mySession');
//# sourceMappingURL=authSession.js.map